import React from 'react';
import { Timer } from 'lucide-react';
interface TopBarProps {
  timeLeft: {
    hours: number;
    minutes: number;
    seconds: number;
  };
}
export function TopBar({
  timeLeft
}: TopBarProps) {
  const formatTime = (val: number) => val.toString().padStart(2, '0');
  return <div className="bg-dark text-white py-2 px-3 sticky top-0 z-50 w-full shadow-md" data-id="element-347">
      <div className="max-w-6xl mx-auto flex flex-row justify-center items-center gap-3 sm:gap-6 text-[11px] sm:text-sm font-medium" data-id="element-348">
        <div className="flex items-center gap-1.5 sm:gap-2 text-gold" data-id="element-349">
          <Timer size={14} className="animate-pulse shrink-0" data-id="element-350" />
          <span className="hidden sm:inline" data-id="element-351">OFERTA EN VIVO · Termina en</span>
          <span className="font-display tracking-widest text-base sm:text-lg" data-id="element-352">
            {formatTime(timeLeft.hours)}:{formatTime(timeLeft.minutes)}:
            {formatTime(timeLeft.seconds)}
          </span>
        </div>
        <div className="hidden sm:block w-px h-4 bg-gray-600" data-id="element-353"></div>
        <div className="hidden sm:flex items-center gap-2 text-gray-300" data-id="element-354">
          <span data-id="element-355">Pago seguro Mercado Pago</span>
        </div>
      </div>
    </div>;
}